/**
 * Keeps vendor and SKU on one row when they fit. When the SKU wraps, the
 * spacer between them is hidden so it does not sit alone on either line.
 */
class ProductVendorLink extends HTMLElement {
  /** @type {ResizeObserver | undefined} */
  #resizeObserver;

  /** @type {MutationObserver | undefined} */
  #mutationObserver;

  connectedCallback() {
    this.#resizeObserver = new ResizeObserver(() => this.#syncSpacer());
    this.#resizeObserver.observe(this);

    this.#mutationObserver = new MutationObserver(() => this.#syncSpacer());
    this.#mutationObserver.observe(this, {
      subtree: true,
      childList: true,
      characterData: true,
    });

    this.#syncSpacer();
  }

  disconnectedCallback() {
    this.#resizeObserver?.disconnect();
    this.#mutationObserver?.disconnect();
  }

  #syncSpacer() {
    const spacer = this.querySelector('[data-spacer]');
    const vendor = this.querySelector('[data-vendor]');
    const skuHost = this.querySelector('[data-sku]');
    const skuText = this.querySelector('.sku');

    if (!(spacer instanceof HTMLElement) || !(vendor instanceof HTMLElement) || !(skuHost instanceof HTMLElement)) {
      return;
    }

    const skuVisible = skuHost.style.display !== 'none' && (skuText?.textContent ?? skuHost.textContent).trim() !== '';
    const vendorVisible = vendor.textContent.trim() !== '';

    if (!skuVisible || !vendorVisible) {
      spacer.hidden = true;
      return;
    }

    spacer.hidden = false;

    const skuWidth = skuText instanceof HTMLElement ? skuText.offsetWidth : skuHost.offsetWidth;
    const gap = Number.parseFloat(getComputedStyle(this).columnGap) || 0;
    const fits = vendor.offsetWidth + spacer.offsetWidth + skuWidth + gap * 2 <= this.clientWidth + 0.5;

    spacer.hidden = !fits;
  }
}

if (!customElements.get('product-vendor-link')) {
  customElements.define('product-vendor-link', ProductVendorLink);
}
